import { environment } from 'src/environments/environment';

const ABSOLUTE_URL = /^(https?:)?\/\//i;
const INLINE_URL = /^(data|blob):/i;
const PRIVATE_PREFIXES = ['assets/images/kyc/', 'assets/images/private/', 'uploads/bankReceipts/'];

export function resolveMediaUrl(value: string | null | undefined): string {
  const stored = (value ?? '').trim();
  if (!stored) return '';
  if (ABSOLUTE_URL.test(stored) || INLINE_URL.test(stored)) return stored;

  const key = stored.replace(/^\/+/, '');
  const base = PRIVATE_PREFIXES.some((prefix) => key.startsWith(prefix))
    ? new URL(environment.apiUrl).origin
    : environment.fileUrl;

  return `${base.replace(/\/+$/, '')}/${key}`;
}
